import { get } from 'lodash';

export function resolveCalendarDatePreferenceKey(userPreference) {
    const o = userPreference?.order_by_date;
    if (o === 'start_date' || o === 'late_submission') return o;
    return 'due_date';
}

export function getAssignmentCalendarSortKey(x) {
    if (!x) return '';
    if (x.type === 'worksheet') return `ws:${String(x.session_id ?? x.id ?? '')}`;
    if (x.quizId != null && x.quizId !== '') return `qz:${String(x.quizId)}`;
    if (x.activityId != null && x.activityId !== '') return `ac:${String(x.activityId)}`;
    return `id:${String(x.data?.id ?? '')}`;
}

export function sortAssignmentsByCalendarOrder(items, orderedKeys) {
    if (!Array.isArray(items) || items.length === 0) return items || [];
    const keys = Array.isArray(orderedKeys) ? orderedKeys : [];
    const keyOf = (x) => getAssignmentCalendarSortKey(x);
    const mapByKey = new Map(items.map((x) => [keyOf(x), x]));
    const seen = new Set();
    const result = [];
    for (const k of keys) {
        const x = mapByKey.get(k);
        if (x) {
            result.push(x);
            seen.add(k);
        }
    }
    for (const x of items) {
        const k = keyOf(x);
        if (!seen.has(k)) result.push(x);
    }
    return result;
}

export function getCalendarDayOrderForClass(userPreference, classId, datePrefKey, dayMoment) {
    const dayKey = dayMoment.format('YYYY-MM-DD');
    return get(userPreference?.calendar_assignment_order, [classId, datePrefKey, dayKey], null);
}
